import React, { useContext, useMemo, useState } from "react"
import { useAnimationClass } from "../components/use-animation"
import { Alert } from "../components/Alert"
import { appendMembers, loadAudience } from "../audience-api"
import { AudienceContext, useAudience } from "./AudienceStore"
import { useNavigate } from "react-router-dom"
import { useAddToast } from "../components/Toasts"
import { LoadingButton } from "../components/SavingButton"

export type Row = {
    [key:string] : string | number
}

function getHeaders(rows:Row[]):string[]{
    if(!rows || rows.length == 0) return null
    return Object.keys(rows[0])
}

export function useHeaders(rows:Row[]){
    return useMemo(() =>{
        return getHeaders(rows);
    }, [rows])
}

export function TableHeader({cols}:{cols: string[]}){
    return <tr>
        {cols.map((c, i)=> <th key={i}>{c}</th>)}
    </tr>
}

export function TableRow({cols, row}:{cols: string[], row: Row}){
    return <tr>
        {cols.map((c, i)=> <td key={i}>{row[c]}</td>)}
    </tr>
}

export function FilePreview({rows}:{rows:Row[]}){
    const headers:string[] = useHeaders(rows);
    const [field, setField] = useState("");
    const [error, setError] = useState("");
    const [shakeClass, animateShake] = useAnimationClass("shake")
    const audience = useAudience();
    const navigate = useNavigate();
    const {dispatch} = useContext(AudienceContext);
    const addToast = useAddToast();
    const [loading, setLoading] = useState(false);

    if(!headers) return <p>Nenhuma linha disponível</p>

    function triggerError(error:string){
        animateShake();
        setError(error);
    }

    async function addMembers(){
        if(!field) 
            return triggerError("Escolha um campo de contato")
        if(loading)
            return;
        try{
            setLoading(true)
            await appendMembers(audience.id, field, rows);
            let newAudience = await loadAudience(audience.id);  
            dispatch({type:"setAudience", payload: newAudience})
            navigate(-1)
            addToast(`${rows.length} contatos adicionados!`, 'bg-success');
        }catch(ex){
            triggerError("Erro ao enviar arquivo")
        }
        setLoading(false);
    }

    return <>
        <div className="my-4 fw-bold">Preview do Arquivo</div>
        <div className="table-view" style={{maxHeight: "calc(100vh - 312px)", position: "relative", overflow:"auto"}}>
            <table className="table table-striped table-hover">
                <thead><TableHeader cols={headers} /></thead>
                <tbody>
                    {rows.map((r, i) => <TableRow key={i} cols={headers} row={r} />)}
                </tbody>
            </table>
        </div>
        <div className="mt-4">
            <p>Utilize o menu abaixo para escolher o campo que contem o número de telefone:</p>
            <select className="form-select mb-3" style={{width:"fit-content"}} onChange={(e) => setField(e.target.value)} value={field}>
                <option key='empty' value="">Campo Contato...</option>
                {headers.map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            {error != '' && <Alert className={`alert-danger ${shakeClass}`} content={error} onDismiss={() => setError("")} />}
            <LoadingButton saving={loading} className="btn btn-primary" onClick={() => addMembers()}>
                Importar contatos
            </LoadingButton>
        </div>
        
    </>
}